import {DrawingDataItemLine} from "./drawingDataItemLine";
import {DrawingDataItemArrow} from "./drawingDataItemArrow";
import {DrawingDataItemColumns} from "./drawingDataItemColumns";
import {DrawingDataItemRows} from "./drawingDataItemRows";
import {DrawingDataItemAngle} from "./drawingDataItemAngle";
import {DrawingDataItemShape} from "./drawingDataItemShape";
import {DrawingDataItemCross} from "./drawingDataItemCross";
import {DrawingDataItemTriangle} from "./drawingDataItemTriangle";
import {DrawingDataItemSquare} from "./drawingDataItemSquare";
import {DrawingDataItemCircle} from "./drawingDataItemCircle";
import {DrawingDataItem} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemBuilder {
    public static create(typeValue: string, subtypeValue: string): DrawingDataItem {
        switch(typeValue) {
            case 'line':
                return new DrawingDataItemLine(subtypeValue as any);
            case 'arrow':
                return new DrawingDataItemArrow();
            case 'columns':
                return new DrawingDataItemColumns();
            case 'rows':
                return new DrawingDataItemRows();
            case 'angle':
                return new DrawingDataItemAngle(subtypeValue as any);
            case 'shape':
                return new DrawingDataItemShape();
            case 'cross':
                return new DrawingDataItemCross();
            case 'triangle':
                return new DrawingDataItemTriangle();
            case 'square':
                return new DrawingDataItemSquare();
            case 'circle':
                return new DrawingDataItemCircle();
        }
        throw new Error('Not a supported type');
    }
}